// extracted by mini-css-extract-plugin
export default {"palletsPricingPerAddressesTableHeader":"PalletsPricing_palletsPricingPerAddressesTableHeader__fh-16"};